import { renderFronto } from "../fronto/fronto.js";

export async function renderVirtual(sel, spec) {
  let v = document.getElementById("virtual");
  let c = document.createElement("DIV");
  c.setAttribute("id", "virtual-" + sel);
  v.appendChild(c);
  return await renderFronto("#virtual-" + sel, spec)
}

export async function clearVirtual() {
  let v = document.getElementById("virtual");
  v.innerHTML = "";
}